// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__fM2df","warning":"Alert_warning__dzk8U","li_data":"Alert_li_data__bL-0r"};